// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
  width: 1.25rem;
  height: 1.25rem;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.spinner .circle {
  opacity: 25%;
}
.spinner .path {
  opacity: 75%;
}`, "",{"version":3,"sources":["webpack://./src/components/custom-button/CustomBtnSpinnerStyles.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;EACA,kCAAA;AACF;AACE;EACE;IACE,uBAAA;EACJ;EACE;IACE,yBAAA;EACJ;AACF;AACE;EACE,YAAA;AACJ;AACE;EACE,YAAA;AACJ","sourcesContent":[".spinner {\n  width: 1.25rem;\n  height: 1.25rem;\n  animation: spin 1s linear infinite;\n  //color: inherit;\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  .circle {\n    opacity: 25%;\n  }\n  .path{\n    opacity: 75%;\n  }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
